import { useDispatch } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';

import AdvancedHotkey from './component';
import { goToOrderDetails } from '../../../store/orders/order-details/orders.details.actions';
import { emptyArray } from 'ui-components/default-props/empty';

export const messages = defineMessages({
  name: {
    description: 'view order details hotkey',
    defaultMessage: 'View Order Details',
    id: 'EXKsWb',
  },
});

export const hotkey = ['v'];
export const barcodeContent = '+LP64YK22FRGQ=';

const ViewOrderDetailsHotkey = ({ children, selectedFulfillmentPlanIds, selectedSalesOrderIds = emptyArray }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const onUpdate = useCallback(() => {
    const salesOrderId = selectedSalesOrderIds[0];
    if (selectedFulfillmentPlanIds?.length !== 1 || !salesOrderId) {
      return;
    }
    dispatch(
      goToOrderDetails({
        salesOrderId,
        fulfillmentPlanId: selectedFulfillmentPlanIds[0],
        selectOrderInGrid: true,
      }),
    );
  }, [dispatch, selectedFulfillmentPlanIds, selectedSalesOrderIds]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onUpdate],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

ViewOrderDetailsHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  selectedFulfillmentPlanIds: PropTypes.array.isRequired,
  selectedSalesOrderIds: PropTypes.array,
};

export default ViewOrderDetailsHotkey;
